import * as React from 'react';
import { Icons } from 'components/icons';
import { useTranslation } from 'react-i18next';

import './style.scss';

type Orientation = 'horizontal' | 'vertical';
export interface IOrientationBlockerProps {
    blockCondition: boolean;
    blockOrientation: Orientation;
    blockText: string;
}

export const OrientationBlocker = (props: IOrientationBlockerProps) => {
    let { blockCondition, blockOrientation, blockText } = props;
    const [ currentOrientation, setCurrentOrientation ] = React.useState<Orientation>(null);
    const { t } = useTranslation();

    const adjustOrientation = () => {
        // @ts-ignore
        switch (Math.abs(window.orientation)) {
            case 0: {
                setCurrentOrientation('vertical');
                break;
            }
            case 90: {
                setCurrentOrientation('horizontal');
                break;
            }
            default: {
                setCurrentOrientation('vertical');
            }
        }
    };

    React.useEffect(() => {
        window.addEventListener('orientationchange', adjustOrientation);
        adjustOrientation();
    }, []);

    if (
        blockOrientation === currentOrientation
        && blockCondition
    ) {
        return (
            <div className="orientation-blocker-wrapper">
                <div className="orienataion-blocker">
                    <div className="rotate-icon-wrapper">
                        <Icons.IconRotateDevice />
                    </div>
                    <div className="rotate-text-wrapper">
                        { blockText }
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
};
